import React, { useState, useMemo } from 'react';
import styles from './styles.css';
import { createSpreadsheet } from '../../../actions';
import { useTranslation } from 'react-i18next';
import i18n from '../../../i18n';
const getAllCustomViews = () => {
  const existingViews = window.localStorage.getItem('views');
  return existingViews == null ? {} : JSON.parse(existingViews);
};

const saveCustomView = (saveViewState, viewId) => {
  // Save to LocalStorage
  const allViews = getAllCustomViews();
  const newKey = saveViewState.text;

  if (!Object.keys(allViews).includes(newKey)) {
    allViews[newKey] = viewId;
    window.localStorage.setItem('views', JSON.stringify(allViews));
  } else {
    return i18n.t('Saved view with this name already exists');
  }

  if (saveViewState.checkbox) {
    window.localStorage.setItem('home', viewId);
  }
  return i18n.t('Saved view to library');
};

/* eslint-disable i18next/no-literal-string */
const withCookieDismissParam = (url, includeParam) => {
  if (!includeParam) {
    return url;
  }
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}cookie_accept=1`;
};

const getSharableEmbedView = (embedTabState) => {
  const sharableUrl = withCookieDismissParam(embedTabState.sharableUrl, embedTabState.includeCookieDismissParam);
  return embedTabState.showInIframe
    ? `<iframe
    id="${embedTabState.sharableContainerId}"
    title="${embedTabState.sharableContainerTitle}"
    width="${embedTabState.sharableContainerWidth}"
    height="${embedTabState.sharableContainerHeight}"
    src="${sharableUrl}">
</iframe>
`.trim()
    : `${sharableUrl}`;
};

function copyTable() {
  const el = document.getElementById('mifDataTable');
  var body = document.body,
    range,
    sel;

  range = document.createRange();
  sel = window.getSelection();
  sel.removeAllRanges();
  try {
    range.selectNodeContents(el);
    sel.addRange(range);
  } catch (e) {
    range.selectNode(el);
    sel.addRange(range);
  }
  document.execCommand('Copy');
}

/* eslint-enable i18next/no-literal-string */
export default function Share({ sharableId, urlParams, onClose, previouseModalState, state, onScreenshotTake, onPdfTake }) {
  const { t } = useTranslation();
  const [modalState, setModalState] = useState(
    previouseModalState || {
      activeTab: 'share',
      showEmailInput: false,
      showNotification: false,
      addressEmailToRecipient: '',
      saveToLibraryDialogue: false,
    },
  );

  const [embedTabState, setEmbedTabState] = useState({
    expandAdvanced: false,
    sharableContainerId: 'iiag',
    sharableContainerTitle: t('Ibrahim Index of African Governance (IIAG)'),
    sharableContainerWidth: '100%',
    sharableContainerHeight: 'auto',
    showInIframe: true,
    includeCookieDismissParam: false,
    sharableUrl: window.location.href.replace('data.html', 'embed.html'),
  });

  const [saveViewState, setSaveViewState] = useState({
    checkbox: false,
    text: '',
  });

  const shareText = t('Explore this and 10 years of governance data with the Ibrahim Index of African Governance');

  const subject = t('Data on African Governance via iiag.online');

  const { view: activeView, subview, showAAT } = urlParams;

  const sharableUrl = useMemo(() => (sharableId ? `${window.location.origin}/data.html?v=${sharableId}` : t('Generating view ID')), [sharableId]);

  const body = t('I thought you might be interested in this data from the Mo Ibrahim Foundation: {{sharableUrl}}', { sharableUrl: sharableUrl });

  return (
    <div className={`${styles.modalShare} uk-modal uk-open`}>
      <div className={`${styles.shareModalBody} uk-modal-dialog uk-modal-dialog-share"`}>
        <button className={`uk-modal-close-default uk-close-large ${styles.closeButton}`} uk-icon="icon:close" type="button" onClick={() => onClose(modalState)} />
        <div className={styles.tabsWrapper}>
          <label
            className={`${styles.tabButton} ${modalState.activeTab === 'share' ? styles.tabButtonActive : ''}`}
            onClick={() => {
              setModalState({
                ...modalState,
                activeTab: 'share',
                showNotification: false,
              });
            }}
          >
            <span uk-icon="icon: social" />
            {t('Share')}
          </label>
          <label
            className={`${styles.tabButton} ${modalState.activeTab === 'embed' ? styles.tabButtonActive : ''}`}
            onClick={() => {
              setModalState({
                ...modalState,
                activeTab: 'embed',
                showNotification: false,
              });
            }}
          >
            <span uk-icon="icon: code" />
            {t('Embed')}
          </label>
          {modalState.activeTab === 'share' ? (
            <div className={styles.panel}>
              <input type="text" className={styles.textArea} value={sharableUrl} readOnly onFocus={(event) => event.target.select()} onClick={(event) => event.target.select()} />
              <a
                onClick={(e) => {
                  e.preventDefault();
                  e.target.closest('a').previousSibling.select();
                  navigator.clipboard.writeText(sharableUrl);
                  setModalState({
                    ...modalState,
                    showNotification: 'Copied to clipboard',
                  });
                }}
                href="#"
                className={styles.copyToClipboardButton}
              >
                <span uk-icon="icon: copy" />
              </a>
            </div>
          ) : (
            <div className={styles.panel}>
              <textarea className={`${styles.textArea} ${styles.embedInput}`} readOnly value={getSharableEmbedView(embedTabState)} onFocus={(event) => event.target.select()} onClick={(event) => event.target.select()} />
              <a
                href="#"
                className={styles.copyToClipboardButton}
                onClick={(e) => {
                  e.preventDefault();
                  e.target.closest('a').previousSibling.select();
                  navigator.clipboard.writeText(getSharableEmbedView(embedTabState));
                  setModalState({
                    ...modalState,
                    showNotification: 'Copied to clipboard',
                  });
                }}
              >
                <span uk-icon="icon: copy" />
              </a>
              <div className={styles.advancedWrapper}>
                <div
                  onClick={() =>
                    setEmbedTabState({
                      ...embedTabState,
                      expandAdvanced: !embedTabState.expandAdvanced,
                    })
                  }
                  className={styles.advancedHeader}
                >
                  {t('Advanced options')}
                  {embedTabState.expandAdvanced ? <span uk-icon="icon: minus" /> : <span uk-icon="icon: plus" />}
                </div>
              </div>
              {embedTabState.expandAdvanced ? (
                <div className={styles.advancedBody}>
                  <div>
                    <label>
                      <input
                        type="checkbox"
                        className={styles.checkbox}
                        defaultChecked={embedTabState.includeCookieDismissParam}
                        onChange={(e) => {
                          setEmbedTabState({
                            ...embedTabState,
                            includeCookieDismissParam: e.target.checked,
                          });
                        }}
                      />
                      {t('Dismiss cookie notice')}
                    </label>
                  </div>
                  <div>
                    <label>
                      <input
                        type="checkbox"
                        className={styles.checkbox}
                        defaultChecked={embedTabState.showInIframe}
                        onChange={(e) => {
                          setEmbedTabState({
                            ...embedTabState,
                            showInIframe: e.target.checked,
                          });
                        }}
                      />
                      {t('Display in iFrame')}
                    </label>
                  </div>
                  {embedTabState.showInIframe ? (
                    <div className={styles.gridContainer}>
                      <div>
                        <label>{t('Size')}:</label>
                      </div>
                      <div>
                        <input
                          type="text"
                          className={styles.advancedInput}
                          placeholder={t('Width')}
                          defaultValue={embedTabState.sharableContainerWidth}
                          onChange={(e) => {
                            setEmbedTabState({
                              ...embedTabState,
                              sharableContainerWidth: e.target.value,
                            });
                          }}
                        />
                        <input
                          type="text"
                          className={styles.advancedInput}
                          placeholder={t('Height')}
                          defaultValue={embedTabState.sharableContainerHeight}
                          onChange={(e) => {
                            setEmbedTabState({
                              ...embedTabState,
                              sharableContainerHeight: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : null}
            </div>
          )}
        </div>

        <div className={styles.socialButtonsWrapper}>
          <p className={styles.socialButtonsTitle}>{t('Share via')}:</p>
          <span className={styles.socialButton} title={t('Share to {{service}}', { service: 'LinkedIn' })} uk-icon="icon: linkedin" onClick={() => window.open(`https://www.linkedin.com/shareArticle?mini=true&title=Explore this and 10 years of governance data with the Ibrahim Index of African Governance&summary=test summary&url=${encodeURIComponent(sharableUrl)}`)}></span>
          <span className={styles.socialButton} title={t('Share to {{service}}', { service: 'Facebook' })} uk-icon="icon: facebook" onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(sharableUrl)}`)}></span>
          <span className={styles.socialButton} title={t('Share to {{service}}', { service: 'Bluesky' })} onClick={() => window.open(`https://bsky.app/intent/compose?text=${encodeURIComponent(shareText)} ${encodeURIComponent(sharableUrl)}`)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 512 512" fill="white">
              <path d="M111.8 62.2C170.2 105.9 233 194.7 256 242.4c23-47.6 85.8-136.4 144.2-180.2c42.1-31.6 110.3-56 110.3 21.8c0 15.5-8.9 130.5-14.1 149.2C478.2 298 412 314.6 353.1 304.5c102.9 17.5 129.1 75.5 72.5 133.5c-107.4 110.2-154.3-27.6-166.3-62.9l0 0c-1.7-4.9-2.6-7.8-3.3-7.8s-1.6 3-3.3 7.8l0 0c-12 35.3-59 173.1-166.3 62.9c-56.5-58-30.4-116 72.5-133.5C100 314.6 33.8 298 15.7 233.1C10.4 214.4 1.5 99.4 1.5 83.9c0-77.8 68.2-53.4 110.3-21.8z" />
            </svg>
          </span>
          <span className={styles.socialButton} title={t('Share to {{service}}', { service: 'Twitter' })} onClick={() => window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(sharableUrl)}&hashtags=IIAG&text=${encodeURIComponent(shareText)}`)}>
            <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.0340664 0L5.4393 7.17024L0 13H1.22427L5.98647 7.89585L9.83407 13H14L8.29052 5.42651L13.3534 0H12.1292L7.74358 4.70068L4.2 0H0.0340664ZM1.8344 0.894591H3.74821L12.1994 12.1054H10.2856L1.8344 0.894591Z" fill="white" />
            </svg>
          </span>
          <span className={styles.socialButton} title={t('Share to {{service}}', { service: 'WhatsApp' })} uk-icon="icon: whatsapp" onClick={() => window.open(`https://wa.me/?text=Explore this and 10 years of governance data with the Ibrahim Index of African Governance ${encodeURIComponent(sharableUrl)}`)}></span>
          <span
            className={styles.socialButton}
            title={t('Share by {{service}}', { service: 'Email' })}
            onClick={() => {
              setModalState({
                ...modalState,
                showEmailInput: true,
              });
            }}
          >
            <img src="/dist/src/img/icons/email_icon.svg" />
          </span>
        </div>
        {modalState.showEmailInput ? (
          <div className="justify-content-center pt-3">
            <div className="pt-2 pb-2">
              <label className={styles.emailTitle}>{t('Enter recipient’s email:')}</label>
              <input
                type="email"
                className={styles.textArea}
                placeholder="mymail@mail.com"
                onChange={(e) => {
                  setModalState({
                    ...modalState,
                    addressEmailToRecipient: e.target.value,
                  });
                }}
              />
            </div>
            <a href={`mailto:${modalState.addressEmailToRecipient}?subject=${subject}&body=${body}`} className={`${styles.shareButton} ${styles.confirmButton}`}>
              <span className={styles.buttonIcon} uk-icon="icon: forward" />
              {t('Send email')}
            </a>
          </div>
        ) : null}
        <hr className={styles.devider} />
        <div className={`${styles.shareButtonsWrapper} justify-content-center`}>
          <div
            onClick={() => {
              // global.$(".measure-icon-image").each((_, image) => {
              //   insertImageIntoCanvas({ image });
              // });
              // prepareScreenForScreenshot(activeView, subview);
              // html2canvas stopps DOM therefore blocks information modal animation
              // timeout delays html2canvas library in order to display modal
              onScreenshotTake();
            }}
            className={styles.shareButton}
          >
            <span className={styles.buttonIcon}>
              <img src="/dist/src/img/icons/camera_icon.svg" />
            </span>
            {t('Take screenshot')}
          </div>
          <div
            id="btnDownloadPdf"
            className={styles.shareButton}
            onClick={() => {
              onPdfTake();
            }}
          >
            <span>
              <img src="/dist/src/img/icons/document_pdf_icon_1x.svg" className={styles.buttonIcon} />
            </span>
            {t('Download PDF')}
          </div>
          <div
            onClick={() => {
              setModalState({
                ...modalState,
                saveToLibraryDialogue: !modalState.saveToLibraryDialogue,
              });
            }}
            className={styles.shareButton}
          >
            <span className={styles.buttonIcon}>
              <img src="/dist/src/img/icons/library_icon_1x.svg" />
            </span>
            {t('Save to library')}
          </div>
          {activeView === 'table' && showAAT != 3 ? (
            <>
              <div className={styles.shareButton} onClick={copyTable}>
                <span className={styles.buttonIcon}>
                  <img src="/dist/src/img/icons/copy_icon_dark_1x.svg" />
                </span>
                {t('Copy data')}
              </div>
              {/* <div id="btnDownloadXlsx" class={styles.shareButton}>
                    <span>
                        <img src="/dist/src/img/icons/document_xls_icon_1x.svg" class="" />
                    </span>
                    Download XLS
                </div> */}
              <div
                onClick={() => {
                  createSpreadsheet(sharableUrl, 'csv', state, urlParams);
                }}
                className={styles.shareButton}
              >
                <span className={styles.buttonIcon}>
                  <img src="/dist/src/img/icons/document_csv_icon_1x.svg" />
                </span>
                {t('Download CSV')}
              </div>
            </>
          ) : null}
        </div>
        {modalState.saveToLibraryDialogue ? (
          <>
            <p className={`${styles.saveViewTextArea}`}>
              <input
                type="text"
                className={styles.textArea}
                placeholder={t('Custom view name')}
                onKeyUp={(e) => {
                  setSaveViewState({
                    ...saveViewState,
                    text: e.target.value,
                  });
                }}
              />
            </p>
            {/*<div*/}
            {/*  className={styles.block}*/}
            {/*  onClick={() => {*/}
            {/*    setSaveViewState({*/}
            {/*      ...saveViewState,*/}
            {/*      checkbox: !saveViewState.checkbox,*/}
            {/*    });*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <input*/}
            {/*    type="checkbox"*/}
            {/*    defaultChecked={saveViewState.checkbox}*/}
            {/*    className={styles.checkbox}*/}
            {/*  />*/}
            {/*  <span*/}
            {/*    className="reduced-size-label clickable_pointer"*/}
            {/*    title={t("This view will load as the default when visiting iiag.online")}*/}
            {/*  >*/}
            {/*    {t("Set as home view")}*/}
            {/*  </span>*/}
            {/*</div>*/}
            <div
              onClick={() => {
                const notification = saveCustomView(saveViewState, sharableId);
                if (!notification) {
                  onClose(modalState);
                } else {
                  setModalState({
                    ...modalState,
                    showNotification: notification,
                  });
                }
              }}
              className={`${styles.shareButton} ${styles.confirmButton}`}
            >
              <span uk-icon="icon: bookmark" />
              {t('Confirm save')}
            </div>
          </>
        ) : null}

        <div className={styles.notification_wrapper}>
          {modalState.showNotification ? (
            <span className={styles.spanConfirmation}>
              {modalState.showNotification}
              <i uk-icon="icon: check" />
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
}
